<template>
    <div class="xin">
        <div class="error">
            <img src="/imgs/error_e.png" alt="">
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>
.xin{
    display: flex;
    align-items: center;
    justify-content: center;
}
    .error img{
       
      
        background-size: 100% 100%;
        height: 100%;
        width: 100%;
    }
</style>